<template>
  <div class="container"> Sorry, page not found!
    <router-link class='dashboard-link' to='/dashboard/customers'> Go to dashboard </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.container {
  font-family: Montserrat-Regular;
  font-size: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
}
.dashboard-link {
  text-decoration: none;
  color: inherit;
  font-size: 20px;
  color: red;
  margin-top: 15px;
}
</style>
